import styled from '@emotion/styled';
import React from 'react';

import img from 'src/public/img/mh-logo-text.svg';

const BrandImage = styled.img({
    width: '12em',
    margin: '1.5em 0 0 1.5em',
});

export const BrandWrapper: React.FC = ({ children }) => (
    <>
        <BrandImage src={img} alt="Modern Health" />
        <>{children}</>
    </>
);
